module.exports = __webpack_public_path__ + "img/03.55c3f9f4.jpg";